import { z } from 'zod';
import type { SchemaEntry } from '../create-field-schema-registry';
import { ERRORS } from './errors';

const MAX_LENGTH = 100;

export const name = () => z
  .string({ error: ERRORS.EMPTY })
  .refine(value => Boolean(value.trim()), { message: ERRORS.EMPTY })
  .max(MAX_LENGTH, { message: ERRORS.INVALID_PATTERN });

export default ['name', name] as const satisfies SchemaEntry;
